export default __webpack_public_path__ + "7c0246d.png";